"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
function DefaultBlank() {
    return react_1.default.createElement("p", null, "List is empty...");
}
exports.default = DefaultBlank;
